<template>
  <page-listado>
    <page-header title="Plantillas de Contenido">
      <b-button variant="primary" size="sm" to="/plantillasContenido/crear">
        <v-icon name="plus" width="16" />
        Crear plantilla
      </b-button>
    </page-header>
    <tabla :plantillas="plantillas" />
  </page-listado>
</template>

<script>
import api from "@/services/plantillasContenido.js";
import Tabla from "./TablaPlantillas.vue";
export default {
  components: { Tabla },
  data() {
    return {
      plantillas: [],
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    listar() {
      return api.listar(this.$route.query).then((plantillas) => {
        this.plantillas = plantillas;
      });
    },
  },
};
</script>
